export default __webpack_public_path__ + "static/media/Complaints Procedure - Hendersons - June 2024.3de3095f.pdf";